import { ProspectModel } from '@/models/prospect'

// LL-169: version 1 accounts registered before the optional profile-details page
// shipped and must never be routed by the new resume logic. Version 2 is set
// server-side on the first form submission after deploy.
export const RegistrationFlowVersion = {
  LEGACY: 1,
  PROFILE_DETAILS: 2
}

function toProspect(user) {
  if (!user) return null
  return user instanceof ProspectModel ? user : ProspectModel.parseFromApi({ prospect: user })
}

export function isNewRegistrationFlow(user) {
  const prospect = toProspect(user)
  if (!prospect) return false
  return (
    (prospect.registrationFlowVersion ?? RegistrationFlowVersion.LEGACY) >=
    RegistrationFlowVersion.PROFILE_DETAILS
  )
}

/**
 * Non-skippable checkpoints: the registration form (a) and the selfie (b).
 * Used by route middleware so an unfinished participant cannot browse the app.
 * The profile-details page (c) is deliberately NOT a hard gate — it is optional.
 */
export function getRegistrationRedirect(user) {
  const prospect = toProspect(user)
  if (!prospect) return null
  if (prospect.requireRegistration) return { name: 'CompleteProfile' }
  if (isNewRegistrationFlow(prospect) && !prospect.image) return { name: 'SetAvatar' }
  return null
}

/**
 * Checkpoint (c): new-flow participants who added a selfie but never dismissed the
 * profile-details page are sent back there on their next app open / sign in.
 */
export function getRegistrationResumeRedirect(user) {
  const prospect = toProspect(user)
  if (!prospect) return null
  if (prospect.requireRegistration) return null
  if (!isNewRegistrationFlow(prospect)) return null
  if (!prospect.image) return { name: 'SetAvatar' }
  if (!prospect.registrationDetailsDismissed) return { name: 'ProfileDetails' }
  return null
}
